import {
  ClientSmallBrand,
  clientSmallBrandToSchemeMap,
} from '../types/models/bridge';

export const getReaderExternalUrl = (
  brand: ClientSmallBrand,
  bookId: string,
  cloudId: string,
  location: string
) => {
  const scheme = clientSmallBrandToSchemeMap[brand];
  if (!scheme) {
    throw new Error(`Scheme not found for brand ${brand}`);
  }
  // Encode all parameters to ensure valid URL even with special characters
  return `https://apiv2.readcloud.com/linker?bid=${encodeURIComponent(bookId)}&cid=${encodeURIComponent(cloudId)}&p=${encodeURIComponent(location)}&scheme=${encodeURIComponent(scheme)}`;
};

/**
 * Generate a Universal Link / App Link URL for opening content in the native app.
 * Format: https://{host}/native/read/{cloudId}/{bookId}?p={location}
 *
 * If the native app is installed, iOS Universal Links / Android App Links route
 * the URL into the app via the AASA / assetlinks files at /.well-known/.
 * If not installed, the URL falls back to the webapp's /native/* route in a browser.
 */
export const getDirectNativeAppUrl = (
  bookId: string,
  cloudId: string,
  location: string,
  brand: ClientSmallBrand = 'rc'
): string => {
  const host = brand === 'winc' ? 'winc.app.readcloud.com' : 'app.readcloud.com';
  const base = `https://${host}/native/read/${encodeURIComponent(cloudId)}/${encodeURIComponent(bookId)}`;
  // Only include ?p when we actually have a location — otherwise we'd produce
  // ?p=undefined or ?p= and the reader would either fail to parse it or treat
  // the literal string "undefined" as a page identifier.
  return location ? `${base}?p=${encodeURIComponent(location)}` : base;
};
